import 'events'
window.process = window.process || { env: { DEBUG: undefined } };
window.global = window;